import { appUrls } from '../config';
import { addEvents } from '../reducers/events';
import { setNotification } from '../reducers/notification';

const EVENTS_URL = appUrls.events;

/**
 * Loads events from server using fetch.
 * Sends ADD_EVENTS action to dispatch function provided as parameter.
 * @param {function} dispatch
 */
const getEvents = function getEvents(dispatch) {
  fetch(EVENTS_URL)
    .then(response => response.json())
    .then(data => dispatch(addEvents(data.events))).catch((e) => {
      dispatch(setNotification('Palvelimeen ei saada yhteyttä.'));
    });
};

export default getEvents;



// WEBPACK FOOTER //
// ./src/services/eventFetchService.js